import { Colors } from '@/common/colors/colors';
import PopUp from '@/common/components/PopUp';
import SelectInput from '@/common/components/SelectInput';
import React, { useState } from 'react';
import { InputsWrapper } from './ImportSpendForm.styled';
import { ButtonWrapper } from '../../Spends.styled';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import SubmitButton from '@/common/components/buttons/SubmitButton';
import { SPEND_SOURCES } from '../../../../../common/constants/spend_sources';
import { addSpends } from '@/API/repositories/meta';
import CSVInput from '@/common/components/CSVInput';
import { EXPECTED_CSV_COLUMNS_TEXT } from '../../constants/expectedCsvColumnsText';
import { ExpectedColumnsText } from './ImportSpendForm.styled';
import { MAP_FIELDS_IN_CSV } from '../../constants/mapedGoogleNetworkCSVFields.constants';
import Loading from '@/common/components/Loading';

const ImportSpendForm = ({ setShow, reload }) => {
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();
	const { addMessage } = useMessageQueueContext();
	const [fileContent, setFileContent] = useState();
	const [source, setSource] = useState(SPEND_SOURCES[0]);

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!source) {
			addMessage('Add a source', 'error');
			return;
		}

		if (!fileContent) {
			addMessage('Add a file', 'error');
			return;
		}

		const payload = {
			source: source.value,
		};

		let isParseError = false;
		const spends = fileContent?.slice()?.map((spend) => {
			let result = {};

			MAP_FIELDS_IN_CSV.forEach((mfic) => {
				let t = spend[mfic.from];

				if (!t) {
					isParseError = true;
					return;
				}

				result[mfic.to] = t;
			});

			return {
				...result,
				cost: Number(result.cost.replace(/[^\d,.]/g, '').replace(',', '.')),
			};
		});

		if (isParseError) {
			addMessage(
				'Invalid CSV structure. Expected columns: Kampania, Dzień,Kod waluty, Koszt',
				'error',
			);
			return;
		}
		payload.spends = spends;

		const response = await makeRequest(addSpends.bind(null, payload));

		if (!response?.data) {
			return addMessage('Something went wrong', 'error');
		}
		addMessage('Added spends', 'info');

		setShow(false);
		reload();
	};

	return (
		<>
			{hasUnfilledRequest(addSpends) && <Loading />}
			<PopUp padding='10px 20px 15px' setShow={setShow}>
				<form onSubmit={handleSubmit}>
					<InputsWrapper>
						<SelectInput
							color={Colors.darkBlue}
							name='Source'
							options={SPEND_SOURCES.filter(
								(f) => f.value !== SPEND_SOURCES[1].value,
							)}
							width={120}
							setSelected={(value) => setSource(value)}
							selected={source}
							required
						/>
						<CSVInput setLoadFile={setFileContent} skipLines={2} />
					</InputsWrapper>
					<ExpectedColumnsText>{EXPECTED_CSV_COLUMNS_TEXT}</ExpectedColumnsText>
					<ButtonWrapper>
						<SubmitButton text='Add' />
					</ButtonWrapper>
				</form>
			</PopUp>
		</>
	);
};

export default ImportSpendForm;
